const $root = $('html, body');
const $headerHeight = $(".site-header").outerHeight();

function smoothScrollToClass(_location) {
   $root.animate({
      scrollTop: _location
   }, Math.min(1000, Math.abs($root.scrollTop() - _location) / 2));
}

function errorNotify(error, errData = null) {
   if (errorEmailSent === false) {
      errorEmailSent = true;

      let data = JSON.parse(localStorage.getItem('currentUser'));
      let date = new Date();
      let postData = JSON.stringify({
         'email': data && data.email ? data.email : "",
         'errorMsg': typeof error == "object" ? JSON.stringify(error) : error,
         'timeStamp': date.getTime(),
         'userAgent': navigator.userAgent,
         'location': window.location.href,
         'data': errData ? errData : 'No data'
      });

      const xhr = new XMLHttpRequest();
      xhr.open("POST", "https://chervon-logging.rain-staging.com/index.php");
      xhr.setRequestHeader("Content-Type", "application/json");

      xhr.onload = () => {
         if (xhr.readyState === 4 && xhr.status === 201) {
            console.log(JSON.parse(xhr.responseText));
         } else {
            console.log(`Error: ${xhr.status}`);
         }
      }

      xhr.send(postData);
   }
}

function titleCase(str) {
   str = str.toLowerCase().split(' ');
   for (var i = 0; i < str.length; i++) {
      str[i] = str[i].charAt(0).toUpperCase() + str[i].slice(1);
   }
   return str.join(' ').trim();
}

$(function () {
// start custom jquery validation
// email validation
// 1-9, a-z or A-Z
// @a-z or @A-Z
// .a-z or .A-Z
   $.validator.addMethod("customemailvalidation", function (value, element) {
      if (value.indexOf("mailosaur.net") !== -1) {
         return true;
      } else {
         return this.optional(element) || /[a-zA-Z0-9]+@[a-zA-Z0-9-]+\.[a-zA-Z]|\.[a-zA-Z]+/.test(value);
      }
   }, window.theme.custom.global.error.email);

   $.validator.addMethod("preventonlywhitespace", function (value, element) {
      return (value.trim() !== "") ? true : false
   }, window.theme.custom.global.error.required);

   $.validator.addMethod("lettersOnly", function (value, element) {
      return this.optional(element) || /^[a-zA-Z- ]*$/.test(value);
   }, window.theme.custom.global.error.lettersOnly);

   $.validator.addMethod("noPostOfficeBox", function (value, element) {
      return this.optional(element) || /\b(?:p\.?\s*o\.?|post\s+office)(\s+)?(?:box|[0-9]*)?\b/.test(value) ? false : true;
   }, window.theme.custom.global.error.noPostOfficeBox);

   let allowedRecallSerialCodes = [
      "911",
      "912",
      "026",
      "027",
      "028",
      "029",
      "030",
      "031",
      "121",
      "122",
      "123",
      "124"
   ];

   $.validator.addMethod("recallFormAllowedSerialNumbers", function (value, element) {
      // Extract the first three digits from the input value
      let firstThreeDigits = value.substring(0, 3);

      // Check if the first three digits are in the allowedRecallSerialCodes array
      return this.optional(element) || allowedRecallSerialCodes.includes(firstThreeDigits);
   }, window.theme.custom.global.error.recall_serial_allowed_serial_numbers);
});